<template>
  <div>
    <div class="home-page">
      <div class="title-section">
        <h1>{{ $t('homeOneModule.title') }}</h1>
        <p>{{ $t('homeOneModule.subTitle') }}</p>
      </div>
      <div class="description-section">
        <span class="description-item">{{ $t('homeOneModule.descList[0].content') }}</span>
        <span class="description-item">{{ $t('homeOneModule.descList[1].content') }}</span>
        <span class="description-item">{{ $t('homeOneModule.descList[2].content') }}</span>
      </div>
    </div>
    <div class="home-page-two">
      <div class="asset-section">
        <div class="asset-info" ref="assetInfo">
          <img src="@/assets/imgs/home/zc.png" alt="Asset Info" class="asset-image">
        </div>
      </div>
      <div class="asset-section-content">
        <h1>{{ $t('homeTwoModule.title') }}</h1>
        <p>{{ $t('homeTwoModule.subTitle') }}</p>
      </div>
    </div>
    <div class="home-page-three">
      <div class="asset-section">
        <img src="@/assets/imgs/home/sy.png" alt="Asset Info" class="asset-image">
      </div>
      <div class="asset-section-content">
        <h1>{{ $t('homeThreeModule.title') }}</h1>
        <p>{{ $t('homeThreeModule.subTitle') }}</p>
      </div>
    </div>
    <div class="home-page-four">
      <div class="title-section">
        <h1>{{ $t('homeFourModule.title') }}</h1>
      </div>
      <div class="features-section" >
        <div class="feature-item" v-for="(feature, index) in $t('homeFourModule.subTitleList')" :key="index">
          <img :src="feature.img" alt="Feature Icon" class="feature-icon">
          <h2>{{ feature.title }}</h2>
          <p>{{ feature.subTitle }}</p>
        </div>
      </div>
    </div>
    <div class="app-download">
      <div class="left">
        <div class="logo">
          <img src="@/assets/imgs/home/APP@2x.png" alt="appLogo">
        </div>
        <div class="desc">
          <p>{{ $t('appDownload.title') }}</p>
          <p>{{ $t('appDownload.desc') }}</p>
        </div>
      </div>
      <div class="right">
        <div class="apple-store market-item">
          <a href="https://apps.apple.com/cn/app/ubpay/id6745318416" target="_blank">
            <img src="@/assets/imgs/home/apple.png" alt="apple store">
            <span>App Store</span>
          </a>
        </div>
        <div class="google-play market-item">
          <a href="https://play.google.com/store/apps/details?id=io.ubcard.ubpay" target="_blank">
            <img src="@/assets/imgs/home/google.png" alt="google play">
            <span>Google Play</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  components: {
  },
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
  },
  mounted() {

  },
};
</script>

<style lang="less" scoped>
.home-page {
  position: relative;
  width: 100%;
  height: 500px;
  background-size: cover;
  background-image: url('~@/assets/imgs/home/banner@1x.png');
  background-repeat: no-repeat;
  background-position: center;
  align-content: center;
  z-index: 500;

  .title-section {
    color: #fff;
    h1 {
      font-size: 48px;
      margin-left: 178px;
    }

    p {
      font-size: 20px;
      margin-left: 178px;
      margin-bottom: 30px;
    }
  }

  .description-section {
    margin-left: 178px;

    .description-item {
      display: inline-block;
      margin-right: 15px;
      padding: 5px 15px;
      border: 1px solid #fff;
      border-radius: 20px;
      font-size: 16px;
      background-color: #fff;
    }
  }
}

.home-page-two {
  position: relative;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 25%;
    background-image: url('~@/assets/imgs/home/zcbg.png');
    background-size: cover;
    background-position: center;
    z-index: 0;
  }

  .asset-section {
    text-align: center;
    align-content: center;
    height: 400px;
    width: 50%;
    margin: 50px auto;
    z-index: 1;
    overflow: hidden;

    .asset-info {
      animation: scrollUp 5s linear infinite;
    }

    .asset-image {
      width: 400px;
      height: auto;
    }

    @keyframes scrollUp {
      0% {
        transform: translateY(30%);
      }
      100% {
        transform: translateY(-10%);
      }
    }
  }

  .asset-section-content {
    width: 50%;
    text-align: center;
    align-content: center;
    h1 {
      font-size: 48px;
      padding: 30px;
    }
    p {
      font-size: 28px;
      padding: 30px;
    }
  }
}

.asset-section,
.asset-section-content {
  position: relative;
  z-index: 1;
}

.home-page-three {
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

  .asset-section {
    text-align: center;
    align-content: center;
    height: 400px;
    width: 50%;
    margin: 50px auto;
    z-index: 1;
    overflow: hidden;

    .asset-image {
      width: 400px;
      height: auto;
    }
  }

  .asset-section-content {
    width: 50%;
    text-align: center;
    align-content: center;

    h1 {
      font-size: 48px;
      padding: 30px;
    }

    p {
      font-size: 28px;
      padding: 30px;
    }
  }
}

.home-page-four {
  position: relative;
  width: 100%;
  padding: 70px 20px;
  background-color: #f8f9fa;

  .title-section {
    text-align: center;
    h1 {
      font-size: 48px;
      margin-bottom: 30px;
    }
  }

  .features-section {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;

    .feature-item {
      width: 25%;
      min-height: 270px;
      text-align: center;
      background-color: #fff;
      border-radius: 30px;
      padding: 30px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      .feature-icon {
        width: 40px;
        margin-bottom: 20px;
      }
      h2 {
        font-size: 26px;
        margin-bottom: 10px;
      }
      p {
        font-size: 20px;
        color: #666;
      }
    }
  }
}

.app-download {
  min-height: 210px;
  background-image: url('~@/assets/imgs/home/downloadbg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 55px 100px;
}

.left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .logo {
    img {
      width: 100px;
    }
  }
  .desc {
    margin-left: 20px;
    color: #ffffff;
    p:first-child {
      font-size: 20px;
      margin: 10px 0;
    }
    p:last-child {
      font-size: 20px;
      margin: 10px 0;
    }
  }
}

.right {
  display: flex;
  justify-content: center;
  align-items: center;
  .market-item {
    width: 140px;
    height: 46px;
    background-color: #3d3d3d;
    margin: 0px  10px;
    align-content: center;
    img {
      margin-left: 15px;
      width: 26px;
      vertical-align: middle;
    }
    span {
      margin-left: 5px;
      display: inline-block;
      font-size: 16px;
      color: #FFFFFF;
      vertical-align: middle;
    }
  }
}
</style>

